import { EyeIcon, ArrowsRightLeftIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { useImpersonation } from '../../context/ImpersonationContext.js';
import CopyButton from '../../ui/CopyButton.js';

/** Sticky amber bar shown while an admin is viewing the platform as another user. */
export default function ImpersonationBanner() {
  const { isImpersonating, impersonated, stop, openPicker } = useImpersonation();
  if (!isImpersonating || !impersonated) return null;

  const label = impersonated.email || impersonated.name || impersonated.userId;

  return (
    <div className="sticky top-14 z-30 border-b border-amber-200 bg-amber-50 px-4 py-2 text-amber-900 sm:px-6 lg:px-8" role="status">
      <div className="mx-auto flex max-w-8xl flex-wrap items-center gap-x-3 gap-y-1.5 text-sm">
        <span className="inline-flex items-center gap-1.5 font-semibold">
          <EyeIcon className="h-4 w-4 text-amber-600" aria-hidden="true" />
          Viewing as
        </span>
        <span className="truncate font-medium">{label}</span>
        {impersonated.email && (
          <span className="hidden items-center gap-1 font-mono text-xs text-amber-700 sm:inline-flex">
            {impersonated.userId}
            <CopyButton value={impersonated.userId} size="xs" className="text-amber-600 hover:text-amber-900" message="User id copied" />
          </span>
        )}
        <span className="rounded-md bg-amber-100 px-1.5 py-0.5 text-2xs font-semibold uppercase tracking-wider text-amber-800 ring-1 ring-inset ring-amber-200">Read-only</span>
        <span className="ml-auto flex items-center gap-1.5">
          <button type="button" onClick={openPicker} className="inline-flex h-7 items-center gap-1.5 rounded-md bg-white px-2.5 text-xs font-semibold text-amber-900 ring-1 ring-inset ring-amber-200 transition hover:bg-amber-100">
            <ArrowsRightLeftIcon className="h-3.5 w-3.5" aria-hidden="true" />
            Switch user
          </button>
          <button type="button" onClick={stop} className="inline-flex h-7 items-center gap-1.5 rounded-md bg-amber-600 px-2.5 text-xs font-semibold text-white transition hover:bg-amber-700">
            <XMarkIcon className="h-3.5 w-3.5" aria-hidden="true" />
            Exit
          </button>
        </span>
      </div>
    </div>
  );
}
